<template>
  <section>
    <!--工具条-->
    <el-form :inline="true" class="toolbar" :model="searchForm">
      <el-form-item label="商户单号">
        <el-input v-model="searchForm.orderNo" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="支付单号">
        <el-input v-model="searchForm.tradeNo" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="交易状态">
        <el-select v-model="searchForm.status" size="mini" style="width: 100px" clearable>
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="请求日期">
        <el-date-picker
          v-model="searchForm.searchDate"
          type="date"
          value-format="yyyy-MM-dd"
          size="mini"
          style="width: 150px"
          clearable
          placeholder="请求日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary" size="mini">查询</el-button>
        <el-button @click="downloadDataList" type="primary" size="mini">导出明细</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      border
      height="650"
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column
        prop="no"
        label="序号"
        width="50"
        type="index"
      ></el-table-column>
      <el-table-column prop="orderNo" align="center" label="商户单号"></el-table-column>
      <el-table-column prop="tradeNo" align="center" label="支付单号"></el-table-column>
      <el-table-column prop="status" align="center" label="交易状态">
        <template slot-scope="scope">
          <span>{{ getOrderStatus(scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="utr" label="UTR"></el-table-column>
      <el-table-column
          prop="amount"
          header-align="center"
          align="right"
          label="交易金额">
        <template slot-scope="scope">
          <span>{{ scope.row.amount / 100 }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="fee"
          header-align="center"
          align="right"
          label="手续费">
        <template slot-scope="scope">
          <span>{{ scope.row.fee / 100 }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="createTime"
          align="center"
          label="订单时间">
        <template slot-scope="scope">
          <span>{{ dateTransform(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="dealTime"
          align="center"
          label="结果时间">
        <template slot-scope="scope">
          <span>{{ dateTransform(scope.row.dealTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="notifyStatus"
          label="回调状态"
          align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.notifyStatus == 0">未回调</span>
          <span v-if="scope.row.notifyStatus == 1">已回调</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      @size-change="pageSizeChange"
      @current-change="pageIndexChange"
      :current-page="pageIndex"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="dataTotal"
    ></el-pagination>
  </section>
</template>

<script>
import api from "../../api/orderManage/payInList";
import Enum from "../../utils/Enum/Enum";
import DataUtil from "../../utils/config/dataUtil";

export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      dataTotal: 0,
      loading: false,
      tableData: [],
      statusList: Enum.orderStatus,
      searchForm: {
        orderNo: "",
        tradeNo: "",
        status: "",
        searchDate: new Date().toISOString().split('T')[0],
      },
      merchantList: [],
    };
  },
  methods: {
    dateTransform(date) {
      return DataUtil.dateTransform(date);
    },
    getOrderStatus(val) {
      return Enum.getOrderStatus(val);
    },
    search() {
      this.pageIndex = 1;
      this.bindGrid();
    },
    bindGrid() {
      this.loading = true;
      this.searchForm.isDownload = false;
      if (this.searchForm.startTime == null) {
        this.searchForm.startTime = "";
      }
      let _data = {};
      let content = Object.assign({}, this.searchForm);
      content.pageNo = this.pageIndex;
      content.pageSize = this.pageSize;
      _data.content = content;
      api.getPayInList(_data).then((res) => {
        this.logining = false;
        if (res.code == "0000") {
          this.loading = false;
          this.tableData = res.data.rows;
          this.dataTotal = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    async downloadDataList() {
      this.searchForm.isDownload = true;
      if (!this.searchForm.searchDate) {
        this.$message.error("请选择日期");
        return;
      }

      let response;
      try {
        response = await api.getPayInSearchDownload({ content: { ...this.searchForm } });
      } catch (error) {
        console.error('下载请求异常', error);
        this.$message.error("网络请求失败，请稍后重试");
        return;
      }

      // 处理 response 可能是完整响应对象或直接是 Blob 的情况
      let res = response?.data ?? response; // 优先取 response.data，否则直接用 response

      if (!res) {
        this.$message.error("下载数据为空");
        return;
      }

      // 检查是否为 JSON 错误信息（确保 res 是 Blob 且有 type 和 size 属性）
      if (res.type === "application/json" || (res.size !== undefined && res.size < 1024)) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const result = JSON.parse(reader.result);
            if (result.code && result.code !== 200) {
              this.$message.error(result.message || "下载失败，请稍后重试");
            } else {
              this.$message.error("下载失败，请稍后重试");
            }
          } catch {
            this.$message.error(reader.result || "下载失败，请稍后重试");
          }
        };
        reader.readAsText(res);
        return;
      }

      // 从响应头 Content-Disposition 提取文件名
      let fileName = null;
      const disposition = response?.headers?.['content-disposition']; // 注意：如果 response 是 Blob，就没有 headers
      if (disposition) {
        const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match && match[1]) {
          fileName = match[1].replace(/['"]/g, '');
        }
      }

      // 如果未提取到文件名，则回退到前端生成
      if (!fileName) {
        const d = new Date();
        const timestamp = (d.getFullYear() + '').slice(-2) +
          ('0' + (d.getMonth() + 1)).slice(-2) +
          ('0' + d.getDate()).slice(-2) +
          ('0' + d.getHours()).slice(-2) +
          ('0' + d.getMinutes()).slice(-2) +
          ('0' + d.getSeconds()).slice(-2);
        const ext = res.type === "application/zip" ? ".zip" : ".xlsx";
        fileName = `PayIn_${timestamp}${ext}`;
      }

      // 创建下载链接
      const blob = new Blob([res], { type: res.type });
      const downloadURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadURL;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(downloadURL);
    },

    // 分页
    pageSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.bindGrid();
    },
    pageIndexChange(val) {
      this.pageIndex = val;
      this.bindGrid();
    },
  },
  mounted: function() {
  },
  components: {},
};
</script>

<style lang="scss">
@import "../../assets/css/base";
.el-form-item {
  margin-bottom: 10px;
}
</style>
